import React, { useState } from "react";
import { ElementContainer } from "../../components/containers/styledComponents";
import { Checkbox } from "../../components/visuals/Checkbox";
import { CompassParagraph } from "../../components/common/styledComponents";

export const PwAndCheckboxLine = (): JSX.Element => {
  const [checked, setChecked] = useState(false);
  return (
    <ElementContainer ai="center">
      <label>
        <Checkbox
          checked={checked}
          onChange={(): void => setChecked(!checked)}
        />
      </label>
      <CompassParagraph>Remember me</CompassParagraph>
    </ElementContainer>
  );
};
